export enum ProgressBarVariant {
  GREEN = "green",
  BLUE = "blue",
  RED = "red",
}

export const PROGRESS_BAR_FILL_CLASS: Record<ProgressBarVariant, string> = {
  [ProgressBarVariant.GREEN]: "fillGreen",
  [ProgressBarVariant.BLUE]: "fillBlue",
  [ProgressBarVariant.RED]: "fillRed",
};
